export default class QuestionInput extends PIXI.Container {
    constructor(question, view) {
        super();

        this._question = question;

        this._view = view;
        this._view.signals.select.add(this.onInputButtonClick, this);

        this._tutorialHand = null;
        this._tutorialHandTweens = new P3.utils.TWEEN.Group();
        this._tutorialHandRunning = false;
    }

    init() {
        this.initTutorial();
    }

    destroy() {
        this._tutorialHandTweens.removeAll();

        super.destroy({children: true});
    }

    update(dt) {
        this._tutorialHand.update(dt);
        this._tutorialHandTweens.update();
    }

    lock() {
        // override
    }

    unlock() {
        // override
    }

    setInteractive(value) {
        // override
    }

    showCorrectAnswer() {
        // override
    }

    onInputButtonClick(input) {
        // override
    }

    initTutorial() {
        const sequence = new P3.MovieClipSequence();
        sequence.addTextures([P3.assets.texture("tutorial_finger")], "default");
        sequence.addTextures([P3.assets.texture("tutorial_finger_tap"), P3.assets.texture("tutorial_finger")], "tap");

        this._tutorialHand = new P3.MovieClip(sequence, "default", false);
        this._tutorialHand.anchor.set(0.1, 0.04);
        this._tutorialHand.hitArea = new PIXI.Rectangle();
        this._tutorialHand.visible = false;
        this._tutorialHand.animationSpeed = 1;
        this.addChild(this._tutorialHand);
    }

    animateTutorial() {
        // override
    }

    showTutorial() {
        this._tutorialHandRunning = true;

        this.animateTutorial();
        this.addChild(this._tutorialHand);
    }

    hideTutorial() {
        this._tutorialHandRunning = false;

        this._tutorialHandTweens.removeAll();
        this._tutorialHand.visible = false;
    }

    calculateFontSize(options) {
        let size = 40;

        let longest = 0;

        for (let i = 0; i < options.length; ++i)
        {
            const value = options[i];
            const str = value.toString();

            if (str.length >= 8)
            {
                if (str.length > longest)
                {
                    longest = 7;
                    size = 15;
                }
            }
            else if (str.length >= 5)
            {
                if (str.length > longest)
                {
                    longest = 5;
                    size = 18;
                }
            }
        }
        return size;
    }

    get question() {
        return this._question;
    }

    get view() {
        return this._view;
    }
}

QuestionInput.INPUT_SELECT              = "select";
QuestionInput.INPUT_SELECT_SUM          = "select_sum";
QuestionInput.INPUT_SELECT_MULTI        = "select_multi";
QuestionInput.INPUT_SELECT_MULTI_SUM    = "select_multi_sum";
QuestionInput.INPUT_SELECT_VISUAL       = "select_visual";
QuestionInput.INPUT_SELECT_MULTI_GRAPH  = "select_multi_graph";
QuestionInput.INPUT_SELECT_TIME         = "select_time";
QuestionInput.INPUT_KEYPAD              = "keypad";
QuestionInput.INPUT_KEYPAD_RIGHT        = "keypad_right";
QuestionInput.INPUT_SORT                = "sort";
QuestionInput.INPUT_SORT_CONVERSION     = "sort_conversion";
QuestionInput.INPUT_SELECT_CLOCK_FACE               = "select_clock_face";
QuestionInput.INPUT_SELECT_MULTI_EQUIVALENT         = "select_multi_equivalent";
QuestionInput.INPUT_SELECT_MULTI_VISUAL         = "select_multi_visual";
QuestionInput.INPUT_SELECT_MULTI_VISUAL_EQUIVALENT  = "select_multi_visual_equivalent";